import { z } from "zod";

export const schema = z.object({
	id_forma: z.number().int("Campo id_empresa é obrigatorio"),
	nome: z.string().min(1, "Campo forma de pagamento é obrigatório"),
	ativo: z.boolean(),
});
